import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

const RevenueTracking = () => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Revenue Tracking (Admin)
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Track revenue from plan purchases and message usage
        </Typography>
        {/* Add revenue tracking component here */}
      </CardContent>
    </Card>
  );
};

export default RevenueTracking;
